import React from "react";
import Icon from "components/MainApp/atoms/Icon/icon";
import styles from "./MainApp.organisms.OrdersV3.LocationSummary.module.scss";
import i18n from "i18n";

const LocationSummary = ({ item, handleDelete }) => {
  return (
    <div className={styles["location-summary-container"]}>
      <div className={styles["location-summary-left"]}>
        <div className={styles["path"]}>{item.title}</div>
        {item.dispatch_area && (
          <div className={styles["items"]}>{i18n.t("new.departure.order")}</div>
        )}
        <div className={styles["items"]}>{i18n.t("products")}({item.items.length})</div>
      </div>
      <div className={styles["location-summary-right"]}>
        {handleDelete && (
          <div onClick={() => handleDelete(item)}>
            <Icon name="trash_can" width={20} height={20} fill={"#3C7AF5"} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSummary;
